import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SupportedCurrencies } from '../../../../../core/constants/currency';
import { OrdersService } from '../../../../../core/services/orders.service';
import { AppUserClaimsService } from '../../../../../core/services/app-user-claims.service';
import { environment } from '../../../../../../environments/environment';
import { SpinnerService } from '../../../../../core/services/spinner.service';
import { AdminService } from 'src/app/core/services/admin.service';

@Component({
  selector: 'app-contact-center-dialog',
  templateUrl: './contact-center-dialog.component.html',
  styleUrls: ['./contact-center-dialog.component.scss'],
})

export class ContactCenterDialogComponent implements OnInit {
	// ccForm: FormGroup;
	disableSaveButton: boolean = true;
	currencyCode: string = '';
	currencyNeeded: boolean = false;
	supportedCodes: string[] = SupportedCurrencies;
	noBillingAccount: boolean = false;
	freeTrialInProgress: boolean = false;
	startQuickSetup: boolean = false;
	quickSetupUrl: string = undefined;
	fullUrl: string = undefined;
	quickSetupClientId: string = environment.callCenterSpa.clientId;
	extraParams: string = undefined;
	productCode: string = '';
	accountId: string = undefined;

	@HostListener('window:message', ['$event'])
	onMessage(event) {
		console.log('CC - iframe child sending messages', event);
		if (event && event.data && event.data.message === 'cx-next-quick-setup-cancelled') {
			this.sendChildUnloadMessage();
			this.onDone();
		} 
		else if (event && event.data && event.data.message === 'cx-next-quick-setup-finished') {
			this.sendChildUnloadMessage();
			this.adminService.getAccountTagsNoFrills(this.accountId, true);
			let result = 
			{
				setupComplete: true,
			}
			this.dialogRef.close( result);
		} 
		else if (event && event.data && event.data.message === 'cx-next-quick-setup-error') {
			this.sendChildUnloadMessage();
			this.onDone(); // need to determine what the error is about and how we should be handling it
		} 
	}

	constructor( @Inject(MAT_DIALOG_DATA) public data: any,
				public dialogRef: MatDialogRef<ContactCenterDialogComponent>,
				private translateService: TranslateService,
				private domSanitizer: DomSanitizer,
				private matIconRegistry: MatIconRegistry,
				private orderService: OrdersService,
				private appClaimsService: AppUserClaimsService,
				private spinnerService: SpinnerService,
				private adminService: AdminService)
	{
        this.productCode = data.product.productCode;
        this.accountId = data.account.accountId;
	}

	showFormError: boolean = false;
	errMsg: string = "";
	errMsgStyle: any = { 'max-width': '500px' };

	ngOnInit() 
	{
		// we would not be in this dialog if everything was set up, so
		// first check to see what state the integration is in with respect to this account
		this.beginQuickStartUp();

	}

	onDone()
	{
		this.sendChildUnloadMessage();
		let result = 
		{
			setupComplete: false,
		}
		this.dialogRef.close( result);
	}

	// to prevent a circular dependency
	sendChildUnloadMessage()
	{
		var iframeSpa= (<HTMLIFrameElement>document.getElementById("iframeSpa"));

		if ( iframeSpa && iframeSpa.contentWindow )
		{
			console.log("Sending an CL_UNLOAD to the child iframe")
			iframeSpa.contentWindow.postMessage("CL_UNLOAD", '*');
		}
	}

	beginQuickStartUp()
	{
		let baseUrl:string;

		if ( window.location.href.indexOf('-stage.dev.') > 0 )
		{
		  baseUrl = environment.callCenterSpa.callCentreStageDevBaseURL;
		}
		else
		{
			baseUrl = environment.callCenterSpa.callCentreBaseURL;
		}

		this.quickSetupUrl = baseUrl;

        if (this.productCode === 'VoiceAssist')
            this.fullUrl = baseUrl + '/embed/setupVoiceAssist/';
        else
            this.fullUrl = baseUrl + '/embed/setup/';
		this.startQuickSetup = true;
	}
}
